import { api } from 'api';
import { isEmpty, isFinite, debounce } from 'lodash';

export default function useAsyncOptions(name_api, initial_params = {}) {
    // Internal function to perform the actual fetch
    const fetchOptions = async (search, params = {}) => {
        const _params = {};

        for (let [key, value] of Object.entries({
            ...initial_params,
            ...params,
        })) {
            if (!isEmpty(value) || isFinite(value)) {
                if (typeof value === 'object' && 'id' in value) {
                    _params[key] = value.id;
                } else {
                    _params[key] = value;
                }
            }
        }
        if (search) _params.search = search;
        _params.async_options = true;
        try {
            const _data = await api.get(name_api, _params);
            if (_data && _data.results) return _data.results;
        } catch (e) {
            return [];
        }
        return [];
    };

    // Debounced version of the fetch function
    // We use a promise-based debounce to work with react-select
    const debouncedFetch = debounce((search, callback) => {
        fetchOptions(search).then(results => callback(results));
    }, 500);

    const asyncOptions = (search, callback) => {
        if (!callback) {
            // If no callback (standard Promise behavior), return the promise
            // Note: react-select/async supports both Promise return and callback
            return fetchOptions(search);
        }
        debouncedFetch(search, callback);
    };

    return { asyncOptions };
}